:host {
  color: var(--text-secondary);
  display: block;
}

.divider {
  display: flex;
  margin: 0;

  &:not(.vertical) {
    width: 100%;
    padding: 4px 0;
    align-items: center;
    justify-content: center;

    .line {
      width: 100%;
      border-top: 1px solid var(--gray-300);
    }

    &.has-content .slot-container {
      padding: 0 6px;
    }
  }

  &.vertical {
    height: 100%;
    padding: 0 4px;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .line {
      height: 100%;
      border-right: 1px solid var(--gray-300);
    }

    &.has-content .slot-container {
      padding: 6px 0;
    }
  }
}

:host(:not([vertical])) {
  width: auto;
}

:host([vertical]) {
  height: auto;
}
